import axiosInstance from "./axiosInstance";
import { axiosInstanceFast } from "./axiosInstance";
// import { realtimeTrafficProps, realtimeAttackProps } from "@/src/components/common/CommonTypes";

export const realtimetraffic = async (data: {
  filters: any;
  productType: string;
}) => {
  if (data.productType === "ndr") {
    const response = await axiosInstanceFast.post(
      "/realtime/traffic/",
      data.filters,
    );
    return response.data.data;
  } else if (data.productType === "ddr") {
    // duplicated because maybe in the future we might need to add some filters or
    // something to be passed along to the api, then we can use that over here.
    const response = await axiosInstanceFast.post("/realtime/traffic/", data);
    return response.data.data;
  }
};

export const anomalylist = async (
  productType: string,
  filter_time: string,
  load_events: boolean = false,
) => {
  if (productType === "ndr") {
    if (filter_time) {
      const response = await axiosInstanceFast.get(
        "/anomaly/anomalies/?load_events=" +
          load_events +
          "&filter_time=" +
          filter_time,
      );
      return response.data.data;
    } else {
      const response = await axiosInstanceFast.get(
        "/anomaly/anomalies/?load_events=" + load_events,
      );
      return response.data.data;
    }
  } else if (productType === "ddr") {
    return [];
  }
};

export const realtimeAttack = async (data: {
  filters: any;
  productType: string;
}) => {
  if (data.productType === "ndr") {
    const response = await axiosInstanceFast.post(
      "/realtime/attacks",
      data.filters,
    );
    return response.data.data;
  } else if (data.productType === "ddr") {
    const response = await axiosInstanceFast.post(
      "/realtime/attacks",
      data.filters,
    );
    return response.data.data;
  }
};

export const gethostlist = async () => {
  const response = await axiosInstanceFast.get(
    "/anomaly/hosts-list?filter_time=day&filter_type=anomaly&dashboard=1",
  );
  return response.data.data;
};

export const twoFactorAuth = async () => {
  const response = await axiosInstanceFast.get(
    "/system/settings/two-factor-auth-settings",
  );
  return response.data.data;
};

export const setUpWizard = async () => {
  const response = await axiosInstance.get("/fetchsetupWizardSettings/");
  return response.data;
};

export const anomalyAlerts = async () => {
  const response = await axiosInstanceFast.get("/anomaly/anomaly-alert");
  return response.data.data;
};

export const recentAlerts = async () => {
  const response = await axiosInstanceFast.get("/anomaly/recent-alerts");
  return response.data.data;
};

export const readRecentAlerts = async () => {
  const response = await axiosInstanceFast.post("/anomaly/read-recent-alerts");
  return response.data.data;
};

export const readSystemAlerts = async () => {
  const response = await axiosInstanceFast.post("/anomaly/read-system-alerts");
  return response.data.data;
};

export const getAutomationApprovalAlerts = async () => {
  const response = await axiosInstance.get("/getAutomationApprovalAlerts/");
  return response.data;
};

export const fetchDeviceProperties = async () => {
  const response = await axiosInstanceFast.get(
    "/system/settings/device-properties",
  );
  return response.data.data;
};

export const distributedSystemsType = async (data: {
  distributed_systems_type: string;
  distributed_systems_master: number;
}) => {
  const response = await axiosInstance.post("/distributedSystemsType/", data);
  return response.data;
};

export const deviceTimeSetup = async (data: { timezone: string }) => {
  const response = await axiosInstance.post("/deviceTimeSetup/", data);
  return response.data;
};

export const airgapOnOffSetting = async (data: { status: number }) => {
  const response = await axiosInstance.post("/airgapOnOffSetting/", data);
  return response.data;
};

export const deviceIpSetup = async (data: {
  ipAddress: string;
  subnetMask: string;
  gateWay: string;
  dnsServer: string;
}) => {
  const response = await axiosInstance.post("/deviceIpSetup/", data);
  return response.data;
};

export const setupWizard = async (data: { action: string }) => {
  const response = await axiosInstance.post("/setupWizard/", data);
  return response.data;
};

export const fetchBasicSettings = async () => {
  const response = await axiosInstanceFast.get(
    "/system/settings/basic-settings",
  );
  return response.data.data;
};

export const fetchBasicSettings_Old = async () => {
  const response = await axiosInstance.post("/fetchSettings/");
  return response.data;
};

export const deviceLocation = async () => {
  const response = await axiosInstanceFast.get(
    "/system/settings/device-coordinate-settings",
  );
  return response.data.data;
};

export const threatLandscape = async () => {
  const response = await axiosInstance.post("/threatLandscape/");
  return response.data;
};

export const vpnAccessLocations = async () => {
  const response = await axiosInstance.post("/vpnAccessLocations/");
  return response.data;
};

export const vpnAccessLogs = async () => {
  const response = await axiosInstance.post("/vpnAccessLogs/");
  return response.data;
};

export const getAllPluginLogo = async () => {
  const response = await axiosInstanceFast.get(
    "/rdd/api/v1/service_name_plugin_logo",
  );
  return response.data.data;
};

export const getVRConnections = async () => {
  const response = await axiosInstanceFast.post(
    "/connection/all-critical-entities/",
  );
  return response.data;
};

export const getAllAutomationApproval = async () => {
  const response = await axiosInstance.get("/getAllAutomationApproval/");
  return response.data.res;
};

export const getShadowGPTTools = async () => {
  const response = await axiosInstanceFast.get(
    "/shadowgpt/get-available-tools",
  );
  return response.data.data;
};
